import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$agentFactory} from "../../../agents/$agent.factory";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ResourceAllocationEditType} from "../../types/resourceAllocationEdit.type";
import {BranchReferenceModel} from "../../../branches/models/branch-reference.model";

export class resourceAllocationPanelViewCtrl implements IController {

  allocation: any;
  template?: any;
  routeId: string;
  resource: any;
  serviceAreas: any;
  resourceTags: string[];
  // branchIds: any;
  branchReferences: BranchReferenceModel[];
  isEdit: boolean;
  isCreate: boolean;
  isDuplicate: boolean;
  onClosePanel: Function;
  onUpdateAllocation: Function;
  onCreateRecurringServiceSequence: Function;
  onCreateAllocation: Function;
  onOpenEditView: Function;
  onOpenCreateView: Function;
  onOpenDuplicateView: Function;
  onTabSelect: Function;

  public isEditSequence: boolean = false;
  public resourceAllocationEditTypes: ResourceAllocationEditType[] = Object.values(ResourceAllocationEditType);
  public resourceAllocationEditType: ResourceAllocationEditType;
  private route: any;
  public depotsRef: any;
  public resourceColor: string;
  public allocationServiceAreas: any;
  public isSameDate: boolean;
  private agentRef: any;
  public isShowActions: boolean;
  public branchIds: string[];
  public branchNames: string[];

  /* @ngInject */
  constructor(private commonsDialogService: CommonsDialogService, private $depots, private $accounts: $accountsFactory, private $serviceArea, private $log,
              private $agent: $agentFactory, private moment, private $route, private leanPlanningService: LeanPlanningService, private commonsService: CommonsService) {
    this.depotsRef = this.$depots();
  }

  $onInit() {
    if (!!this.template) {
      this.resourceAllocationEditType = ResourceAllocationEditType.FUTURE;
    } else {
      this.resourceAllocationEditType = ResourceAllocationEditType.EVENT;
    }
    this.isEditSequence = false;
    this.allocationServiceAreas = [];
    this.resourceColor = this.commonsService.getColorById(_.get(this.allocation, 'resourceAllocationId'));

    if (this.routeId) {
      this.$route(this.routeId).$asyncValue()
        .then((r) => {
          this.route = r;
        })
    }

    if (!this.isCreate) {
      this.isSameDate = this.moment(this.allocation.schedule.startTime).isSame(this.moment(this.allocation.schedule.endTime), 'day');
    }

    if (_.get(this.allocation, 'serviceAreaIds.length')) {
      this._setAllocationServiceAreas(this.allocation.serviceAreaIds);
    }

    this.branchIds = [];
    if (!!this.branchReferences?.length) {
      this.branchIds = this.branchReferences.map((br) => br.id);
      this.branchNames = this.branchReferences.map((br) => br.name);
    }

    // if (_.get(this.allocation, 'details.length')) {
    //   const depotIds = [];
    //   const accountIds = [];
    //
    //   this.allocation.details.forEach((d) => {
    //     if (d.type === "DEPOT") {
    //       depotIds.push(d.holderId);
    //     }
    //     if (d.type === "ACCOUNT") {
    //       accountIds.push(d.holderId);
    //     }
    //   })
    //
    //   if (depotIds.length) {
    //     this._setAllocationDepots(depotIds);
    //   }
    //   if (accountIds.length) {
    //     this._setAllocationAccounts(accountIds);
    //   }
    //
    // }

  }


  $onChanges(changes) {
    if (
      changes.allocation && !changes.allocation.isFirstChange() ||
      changes.resource && !changes.resource.isFirstChange() ||
      changes.branchReferences && !changes.branchReferences.isFirstChange() ||
      changes.isEdit && !changes.isEdit.isFirstChange() ||
      changes.isCreate && !changes.isCreate.isFirstChange() ||
      changes.isDuplicate && !changes.isDuplicate.isFirstChange()
    ) {
      this.$onInit();
    }
  }

  onTabChanged(tab) {
    this.onTabSelect({tab: tab});
  }

  onToggleBlockRoute(route) {
    this.leanPlanningService.editBlockedState(route.id, !route.isBlockedByUser)
      .then((updatedRoute) => {
        this.route = updatedRoute;
      })
  }

  onResourceAllocationEditTypeChange(resourceAllocationEditType: ResourceAllocationEditType) {
    this.resourceAllocationEditType = resourceAllocationEditType;
  }

  onChangeIsEditSequence(isEditSequence) {
    this.isEditSequence = isEditSequence;
    if (!!this.template) {
      this.resourceAllocationEditType = ResourceAllocationEditType.FUTURE;
    } else {
      this.resourceAllocationEditType = ResourceAllocationEditType.EVENT;
    }
  }

  private _setAllocationServiceAreas(serviceAreasIds) {
    this.allocationServiceAreas = _.filter(this.serviceAreas, (sa) => {
      return serviceAreasIds.includes(sa.id);
    });
  }
}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationPanelView', {
    bindings: {
      template: '<?',
      allocation: '<',
      routeId: '<',
      resource: '<',
      isEdit: '<',
      isCreate: '<',
      isDuplicate: '<',
      serviceAreas: '<',
      resourceTags: '<?',
      branchReferences: '<',
      onClosePanel: '&',
      onUpdateAllocation: '&',
      onCreateRecurringServiceSequence: '&',
      onCreateAllocation: '&',
      onOpenEditView: '&',
      onOpenDuplicateView: '&',
      onOpenCreateView: '&',
      onTabSelect: '&'
    },
    template: require('./resource-allocation-panel-view.html').default,
    controller: resourceAllocationPanelViewCtrl
  });
